import { FC } from 'react'

const RevolutPayIcon: FC = () => (
  <svg
    width="40"
    height="26"
    viewBox="0 0 40 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="40"
      height="25"
      rx="4"
      fill="#191C1F"
    />
    <path
      d="M16.707 8.85938H14V20.6281H16.707V8.85938Z"
      fill="white"
    />
    <path
      d="M25.1969 9.52891C25.1969 7.03203 23.3055 5 20.9805 5H14V7.51328H20.6484C21.7008 7.51328 22.5719 8.40234 22.5914 9.49453C22.6008 10.0414 22.4102 10.557 22.0539 10.9477C21.6977 11.3383 21.2211 11.5539 20.7125 11.5539H18.1227C18.0312 11.5539 17.9562 11.6336 17.9562 11.7328V13.9672C17.9562 14.0041 17.9671 14.0403 17.9875 14.0711L22.3828 20.625H25.5992L21.1945 14.0531C23.4133 13.9336 25.1977 11.9305 25.1977 9.52969L25.1969 9.52891Z"
      fill="white"
    />
  </svg>
)

export default RevolutPayIcon
